// extracted by mini-css-extract-plugin
module.exports = {"list":"Styles_list__XIQFO","list__item":"Styles_list__item__zIzSU","list--normal":"Styles_list--normal__TrrML","list--numbered":"Styles_list--numbered__lSv09"};